"use strict";

(() => {
	let upsellProductsRemovedSession = sessionStorage.getItem("upsellProductsRemoved");
	let upsellProductsRemoved;

	if (upsellProductsRemovedSession) {
		upsellProductsRemoved = JSON.stringify(upsellProductsRemoved);
	} else {
		upsellProductsRemoved = [];
		let initialProductsRemovedSession = JSON.stringify(upsellProductsRemoved);
		sessionStorage.setItem("upsellProductsRemoved", initialProductsRemovedSession);
	}

	document.addEventListener("DOMContentLoaded", () => {
		checkCartItemsForUpsell();

		document.addEventListener("rerenderCart", () => {
			checkCartItemsForUpsell();
		});
	});

	/******************************************************************/
	/* check cart items for upsell
	/******************************************************************/

	const checkCartItemsForUpsell = () => {
		// fetch cart
		fetch("/cart.js")
			.then((res) => res.json())
			.then((cart) => {
				const upsellPool = [];

				// loop through dynamicUpsellArrayOfObjects
				dynamicUpsellArrayOfObjects.forEach((dynamicUpsellArrayOfObject) => {
					const productIdsToCheck = dynamicUpsellArrayOfObject.productIdsToCheck;
					const showPermanently = dynamicUpsellArrayOfObject.showPermanently;

					// check if cart contains selected products
					const cartContainsSelectedProducts = productIdsToCheck.some((productIdToCheck) => cart.items.some((cartItem) => cartItem.product_id === productIdToCheck));

					// if cart contains OR item should be shown permanenty, add to upsell pool array 
					if (cartContainsSelectedProducts | showPermanently) {
						upsellPool.push({
							id: dynamicUpsellArrayOfObject.productToShow.id,
							variantId: dynamicUpsellArrayOfObject.productToShow.variantId,
							depositVariantId: dynamicUpsellArrayOfObject.productToShow.depositVariantId,
							handle: dynamicUpsellArrayOfObject.productToShow.handle,
							title: dynamicUpsellArrayOfObject.productToShow.title,
							price: dynamicUpsellArrayOfObject.productToShow.price,
							compareAtPrice: dynamicUpsellArrayOfObject.productToShow.compareAtPrice,
							image: dynamicUpsellArrayOfObject.productToShow.image
						});
					}
				});

				// if cart items greater 0, shift last item to first position, to show last added item
				if (cart.items.length > 0) {
					const lastItem = upsellPool.pop();
					upsellPool.unshift(lastItem);
				}

				// call helper functions for upsell
				buildUpsell(upsellPool);
				handleUpsell(cart.items);
				upsellSwiper();

				const visibleSlides = document.querySelectorAll('.dynamic-upsell__swiper .dynamic-upsell__item:not([style*="display: none"])');
				
				// check visible slides and add padding and show/hide upsell
				if (visibleSlides.length === 0) {
					document.querySelector(".dynamic-upsell").style.display = "none";
				} else {
					document.querySelector(".dynamic-upsell").style.display = "block";
				}
			})
			.catch((error) => {
				console.error("Error fetching cart:", error);
			});
	};

	/******************************************************************/
	/* build upsell
	/******************************************************************/

	const buildUpsell = (upsellPool) => {
		const dynamicUpsellItems = document.querySelector(".dynamic-upsell__items");
		const maxNumberOfUpsellItems = parseInt(document.querySelector(".dynamic-upsell").dataset.maxNumberOfUpsellItems);
		const countryCode = document.querySelector(".dynamic-upsell").dataset.countryCode.toUpperCase();
		let index = 0; 	

		// clear inner html
		dynamicUpsellItems.innerHTML = "";

		// build upsell items
		for (const upsellPoolItem of upsellPool) {

			// break loop if index greater than maxNumberOfUpsellItems
			if (index >= maxNumberOfUpsellItems) break;

			dynamicUpsellItems.insertAdjacentHTML(
				"beforeend",
				`
				<div class="dynamic-upsell__item swiper-slide">
					<div class="dynamic-upsell__item-image">
						<a href="/products/${upsellPoolItem.handle}">
							<img src="${upsellPoolItem.image}"/>
						</a>
					</div>
					<div class="dynamic-upsell__content">
		
						<div class="dynamic-upsell__item-title">
							<a href="/products/${upsellPoolItem.handle}">
								${upsellPoolItem.title}
							</a>
						</div>

						${upsellPoolItem.compareAtPrice ?
							`<div class="dynamic-upsell__item-price-wrapper">
								<span class="dynamic-upsell__item-compare-at-price">${window.Shopify.formatMoney(parseFloat(upsellPoolItem.compareAtPrice), "{{ amount_with_comma_separator }} €")}</span>
								<span class="dynamic-upsell__item-price">${window.Shopify.formatMoney(parseFloat(upsellPoolItem.price), "{{ amount_with_comma_separator }} €")}</span>
							</div>`
							:
							`<div class="dynamic-upsell__item-price">${window.Shopify.formatMoney(parseFloat(upsellPoolItem.price), "{{ amount_with_comma_separator }} €")}</div>`
						}
			
						<div class="dynamic-upsell__quantity-button-wrapper">
						<quantity-input class="quantity cart-quantity">
							<button class="quantity__button no-js-hidden" name="minus" type="button">
								<svg class="icon icon-minus" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
									<path d="M18 12.3127H6" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</button>
							<input class="quantity__input" type="number" data-cart-quantity="2" min="1" step="1" value="1">
							<button class="quantity__button no-js-hidden" name="plus" type="button">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
									<path d="M12 6.31274V12.3127M12 12.3127V18.3127M12 12.3127H18M12 12.3127L6 12.3127" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</button>
						</quantity-input>
						<button class="dynamic-upsell__item-button" data-variant-id="${upsellPoolItem.variantId}" data-deposit-variant-id="${upsellPoolItem.depositVariantId}">
							Add
							<div class="loading-overlay__spinner hidden"></div>
						</button>
						</div>
					</div>
					<svg class="dynamic-upsell__item-remove" width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1 9.375L0.125 8.5L3.625 5L0.125 1.5L1 0.625L4.5 4.125L8 0.625L8.875 1.5L5.375 5L8.875 8.5L8 9.375L4.5 5.875L1 9.375Z" fill="#717171"/>
					</svg>
				</div>
			`,
			);

			index++;
		}
	};

	/******************************************************************/
	/* handle upsell
	/******************************************************************/

	const handleUpsell = (cartItems) => {
		const upsellItems = document.querySelectorAll(".dynamic-upsell .dynamic-upsell__item");
		upsellProductsRemoved = JSON.parse(sessionStorage.getItem("upsellProductsRemoved"));

		upsellItems.forEach((upsellItem) => {
			const upsellButton = upsellItem.querySelector(".dynamic-upsell__item-button");
			const upsellRemove = upsellItem.querySelector(".dynamic-upsell__item-remove");
			const upsellQuantity = upsellItem.querySelector(".quantity__input");
			const loadingSpinner = upsellItem.querySelector(".dynamic-upsell__item .loading-overlay__spinner");
			const variantId = parseInt(upsellButton.dataset.variantId);
			const depositVariantId = parseInt(upsellButton.dataset.depositVariantId);
			const cartHasUpsellItem = cartItems.some((cartItem) => cartItem.variant_id === variantId);
			const quantityControls = document.querySelectorAll(".dynamic-upsell__item .cart-quantity");

			quantityControls.forEach((control) => {
				const quantityInput = control.querySelector(".quantity__input");
				let quantityValue = parseInt(quantityInput.value, 10);
				const incrementButtons = control.querySelectorAll(".quantity__button");
	
				incrementButtons.forEach((button) => {
					button.addEventListener("click", (event) => {
						event.preventDefault();

						quantityValue += button.attributes.name.value == "minus" ? -1 : 1;
						quantityValue = Math.min(Math.max(quantityValue, 1), 9);
						quantityInput.value = quantityValue;
					});
				});
			});

			// handle add to cart button click event
			upsellButton.addEventListener("click", () => {
				loadingSpinner.classList.remove("hidden");
				const quantity = upsellQuantity.value;
				addToCart(variantId, depositVariantId, quantity);
			});

			// hide show upsell item
			if (cartHasUpsellItem || upsellProductsRemoved.includes(variantId)) {
				upsellItem.style.display = "none";
			}

			// handle remove click event
			upsellRemove.addEventListener("click", () => {
				upsellProductsRemoved.push(variantId);

				let uniqueUpsellProductsRemoved = [...new Set(upsellProductsRemoved)];
				let updatedUpsellProductsRemoved = JSON.stringify(uniqueUpsellProductsRemoved);
				sessionStorage.setItem("upsellProductsRemoved", updatedUpsellProductsRemoved);

				upsellItem.style.display = "none";

				setTimeout(() => {
					document.dispatchEvent(new CustomEvent("rerenderCart"));
				}, 100);
			});
		});
	};

	/******************************************************************/
	/* add to cart
	/******************************************************************/

	const addToCart = (variantId, depositVariantId, quantity) => {
		let cartItems;

		if (depositVariantId) {
			cartItems = {
				items: [
					{
						id: depositVariantId,
						quantity: 1,
					},
					{
						id: variantId,
						quantity: 1,
					},
				],
			};
		} else {
			cartItems = {
				id: variantId,
				quantity: quantity,
			};
		}

		document.querySelectorAll(".cart__checkout-button").forEach((checkoutButton) => {
			checkoutButton.disabled = true;
		});

		fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(cartItems),
		})
			.then((response) => response.json())
			.then((response) => {
				fetch(window.location.href)
					.then((response) => {
						if(response.ok) {
							document.dispatchEvent(new CustomEvent("rerenderCart"));
							document.dispatchEvent(new CustomEvent("upsellProductAdded"));
						}
					})
					.catch((e) => {
						console.error(e);
					});
			});
	};

	/******************************************************************/
	/* upsell swiper
	/******************************************************************/

	const upsellSwiper = () => {
		const dynamicUpsellSwiper = document.querySelector(".drawer-cart .dynamic-upsell__swiper");

		if (dynamicUpsellSwiper?.swiper) {
			dynamicUpsellSwiper.swiper.destroy();
		}

		const visibleSlides = document.querySelectorAll('.dynamic-upsell__swiper .dynamic-upsell__item:not([style*="display: none"])');

		new Swiper(".drawer-cart .dynamic-upsell__swiper", {
			loop: false,
			watchSlidesProgress: true,
			simulateTouch: true,
			slidesPerView: 1.56,
 			spaceBetween: 5,
			mousewheel: {
                invert: false
			},
			navigation: {
				prevEl: document.querySelector(".dynamic-upsell .swiper-button-prev"),
				nextEl: document.querySelector(".dynamic-upsell .swiper-button-next")
			},
			pagination: {
				el: document.querySelector(".dynamic-upsell__swiper .swiper-pagination")
			},
			breakpoints: {
				768: {
					slidesPerView: 2.12,
					centerInsufficientSlides: true
				}
			},
		});
	};
})();